// extracted by mini-css-extract-plugin
export var defaultWrapper = "_mn-3";
export var downloadButton = "_mn-4";
export var fileContainer = "_mn-9 _mn-7";
export var fileContainerBase = "_mn-7";
export var fileContainerFixedHeight = "_mn-8 _mn-7";
export var fileInfo = "_mn-5";
export var fileInfoWidthRestricted = "_mn-6";
export var fileType = "_mn-1";
export var fileTypeName = "_mn-2";
export var image = "_mn-0";
export var link = "_mn-b";
export var overflowEllipsis = "_mn-a";